<app-add-material-set-page [textileDataService]="yarnSets" [materialSet]="yarnSetToSave" [hasMaterialSetState]="hasYarnSetState"></app-add-material-set-page>
